import type { ElementType, ReactNode } from 'react'
import { useInView } from '@/hooks/use-in-view'

export type RevealVariant = 'rise' | 'clip' | 'skew' | 'scale' | 'blur' | 'slam'

interface RevealProps {
  children: ReactNode
  variant?: RevealVariant
  delay?: number
  as?: ElementType
  className?: string
  once?: boolean
}

export function Reveal({
  children,
  variant = 'rise',
  delay = 0,
  as: Tag = 'div',
  className = '',
  once = true,
}: RevealProps) {
  const [ref, inView] = useInView<HTMLDivElement>({ once })
  const classes = ['reveal', `reveal--${variant}`, inView ? 'is-visible' : '', className]
    .filter(Boolean)
    .join(' ')
  const style = { '--reveal-delay': `${delay}ms` }

  if (variant === 'clip') {
    return (
      <Tag ref={ref} className={classes} style={style}>
        <span className="reveal__clip">{children}</span>
      </Tag>
    )
  }

  return (
    <Tag ref={ref} className={classes} style={style}>
      {children}
    </Tag>
  )
}
